import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { CircularProgress } from '@material-ui/core';
import { FullscreenPortalContext } from '../context/FullscreenPortalContext';

export default function LoadingLayer({ open = false, label = 'Salvando…' }) {
  const getPortalContainer = React.useContext(FullscreenPortalContext);

  if (!open) return null;

  const container = (getPortalContainer && getPortalContainer()) || document.body;

  return ReactDOM.createPortal(
    <div
      role="status"
      aria-live="polite"
      aria-busy="true"
      style={{
        position: 'absolute',
        inset: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'rgba(0,0,0,0.35)',
        zIndex: 9999,
        pointerEvents: 'all',
      }}
    >
      <div
        style={{
          display: 'flex',
          gap: 12,
          alignItems: 'center',
          padding: '12px 16px',
          borderRadius: 12,
          background: '#fff',
          boxShadow: '0 8px 24px rgba(0,0,0,0.2)',
          fontWeight: 500,
        }}
      >
        <CircularProgress size={24} />
        <span>{label}</span>
      </div>
    </div>,
    container,
  );
}

LoadingLayer.propTypes = {
  open: PropTypes.bool.isRequired,
  label: PropTypes.string,
};

LoadingLayer.defaultProps = {
  label: '',
};
